
import './header.css';
import logo from '../../assets/images/logo.png';
import { Link } from 'react-router-dom';

const Header = () => {

    return (
        
        <div className="header flex items-center justify-between">
            <div className='flex items-center'>
                <img src={ logo } className='logoEmpresa'  alt="Logo Empresa"/>
                <h1 className='font-bold text-xl hidden md:block' >Proteínas y Oleicos</h1>
            </div>
            <div className='md:pr-44'>
                <ul className='flex'>
                    <Link className="font-bold pl-5 pr-5 opcionHover" to="/">INICIO</Link>
                    <Link className="font-bold pl-5 pr-5 opcionHover" to="/contacto">CONTACTO</Link>
                </ul>
            </div>
        </div>

    )
}


export default Header;